import React from 'react';
import { Box, Button } from '@mui/material';

export default function ReminderActions({
  handleViewAllReminders,
  setReminderHandler,
  isEditing = false,
  isLoading = false,
}) {
  return (
    <Box
      className='flexBox'
      sx={{
        width: '100%',
        gap: 2,
        mt: 2,
        flexDirection: 'row',
        justifyContent: 'flex-end',
      }}
    >
      <Button
        variant='text'
        className="reminder-button"
        onClick={handleViewAllReminders}
      >
        View All
      </Button>
      <Button
        autoFocus
        variant='contained'
        className="reminder-button"
        onClick={setReminderHandler}
        disabled={isLoading}
      >
        {isEditing ? 'Update Reminder' : 'Save Reminder'}
      </Button>
    </Box>
  );
} 